'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ENABLED = exports.ENABLED = ['enabled'];

var TIME_DELAY_SECONDS = exports.TIME_DELAY_SECONDS = ['timeDelaySeconds'];